import React from 'react';
import { HeaderProps } from './Haeder.types';
import { Avatar } from 'primereact/avatar';
import { Divider } from 'primereact/divider';
import { useNavigate } from 'react-router-dom';

export const Header: React.FC<HeaderProps> = ({
  children,
  title,
  goBack,
  userName = 'Mas Aly',
  role = 'Admin',
  headerStyle,
  childrenStyle,
}) => {
  const navigate = useNavigate();
  return (
    <header
      className={`bg-bgColor h-[87px] text-white flex flex-col items-center w-full justify-between pt-3 mb-2 ${headerStyle}`}
    >
      <div className="flex justify-between w-full items-center">
        <div className={`flex items-center ${childrenStyle}`}>
          {goBack && (
            <span
              className="cursor-pointer relative top-[2.4px] -left-4 p-0 m-0"
              onClick={() => navigate(-1)}
            >
              <i className="pi pi-angle-left text-3xl"></i>
            </span>
          )}
          {title && <h3 className="text-[25px] font-bold">{title}</h3>}
          {children}
        </div>
        <div className="flex items-center">
          <Divider
            layout="vertical"
            className="bg-[#BFBFBF] w-[1px] mr-4 h-[50px]"
          />
          <Avatar
            image="/avatar.png"
            className="mr-2 w-12 h-12 bg-[#D9D9D9] rounded-full"
          />
          <div>
            <h3 className="font-semibold text-base">{userName}</h3>
            <span className="text-[#BFBFBF] text-xs">{role}</span>
          </div>
        </div>
      </div>
      <div className="mx-[7px] w-full">
        <Divider
          layout="horizontal"
          type="solid"
          className="w-full border border-solid mt-4 border-[#FFFFFF59]"
        />
      </div>
    </header>
  );
};
